export function getOrbyStyle(url) {
    try {
        const params = new URLSearchParams(new URL(url).search);
        const style = params.get("link_style");
        return style && JSON.parse(window.atob(style));
    }
    catch (e) {
        return undefined;
    }
}
export function getNumber(def, value) {
    return value !== undefined ? value : def;
}
